namespace $ {
	export type $shm_surreal_sdk_module = {
		Surreal: new () => any
		Table: new ( name: string ) => any
	}

	export class $shm_surreal_sdk extends $mol_object2 {
		@ $mol_mem
		static lib() {
			$mol_wire_solid()
			return $mol_wire_sync( this ).lib_async()
		}

		static lib_async(): Promise< $shm_surreal_sdk_module > {
			throw new Error('SurrealDB browser SDK is unavailable in this environment')
		}
	}
}
